export function signedOutReturnPath(returnUrl: string | null): string {
  if (!returnUrl || /[^\x21-\x7e]|[\\%]/u.test(returnUrl)) {
    return '/'
  }

  const pathname = returnUrl.split(/[?#]/)[0]
  const match = /^\/app\/v1\/([a-zA-Z0-9][a-zA-Z0-9_-]*)(?:\/[a-zA-Z0-9_-]+)*\/?$/.exec(pathname)
  return match ? `/app/v1/${match[1]}/` : '/'
}
